<template>
  <v-app>
    <v-overlay
      :model-value="true"
      persistent
      scrim="#000000"
      width="100%"
      class="align-center"
    >
      <v-row class="mb-4" justify=center no-gutters>
        <v-alert
          prominent
          color="white"
          max-width="fit-content"
          text="Вас интересует остекление?"
          elevation=4
        >
          <v-row class="mt-2" justify=center no-gutters>
            <div v-ripple.center @click="validateCaptcha" class="text-white bg-primary text-overline mr-3 styled-var">
              Да
            </div>
            <div v-ripple.center @click="validateCaptcha" class="text-white bg-primary text-overline styled-var">
              Нет
            </div>
          </v-row>
          <div v-if="captcha_failed" class="mt-3 text-body-2" style="max-width: 340px;">
            Не удалось загрузить проверку безопасности. Позвоните
            <a href="tel:+7(800)500-40-33" class="font-weight-bold text-decoration-none">8&nbsp;(800)&nbsp;500-40-33</a>
            (бесплатно) или
            <a href="#" @click.prevent="retryCaptcha">попробуйте ещё раз</a>.
          </div>
        </v-alert>
      </v-row>
      <vue-recaptcha
        v-if="captcha_provider !== 'smartcaptcha'"
        ref="recaptcha"
        size="invisible"
        :sitekey="site_key"
        @verify="setAntibotKey"
        @expired="onCaptchaExpired"
        @error="captchaError"
      />
      <SmartCaptchaInvisible
        v-else
        ref="smartcaptcha"
        :sitekey="site_key"
        @verify="setSmartAntibotKey"
        @expired="onCaptchaExpired"
        @error="captchaError"
        @challenge-visible="clearCaptchaTimeout"
      />
    </v-overlay>

    <v-img cover :src="imgUrl"></v-img>
  </v-app>
</template>
<script>
import { railsData } from './init_data/rails_data.js';
import axios from 'axios';

export default {
  name: 'AppAntibot',
  data() {
    return {
      main_domain,
      site_key: railsData.sitekey,
      captcha_provider: railsData.captcha_provider,
      captcha_failed: false,
      captcha_timer: null,
    }
  },
  beforeUnmount() {
    this.clearCaptchaTimeout();
  },
  methods: {
    activeCaptchaRef() {
      return this.captcha_provider === 'smartcaptcha' ? this.$refs.smartcaptcha : this.$refs.recaptcha;
    },
    onCaptchaExpired () {
      const captcha = this.activeCaptchaRef();
      if (captcha) captcha.reset();
    },
    validateCaptcha() {
      this.captcha_failed = false;
      const captcha = this.activeCaptchaRef();
      if (!captcha) {
        this.captchaError('captcha component missing');
        return;
      }
      // Silent-hang timer only for SmartCaptcha: it emits challenge-visible so
      // we can cancel the timer when a real challenge opens. vue-recaptcha has
      // no such event, so a timer there would false-fire mid-challenge — that
      // path keeps its existing @error-driven fallback (behaviour unchanged).
      if (this.captcha_provider === 'smartcaptcha') this.armCaptchaTimeout();
      captcha.execute();
    },
    // Fallback net: if SmartCaptcha never answers (script blocked → execute
    // deferred forever), surface the phone number instead of losing the
    // visitor. Cancelled on challenge-visible / verify / error.
    armCaptchaTimeout() {
      this.clearCaptchaTimeout();
      this.captcha_timer = setTimeout(() => this.captchaError('captcha timeout'), 20000);
    },
    clearCaptchaTimeout() {
      if (this.captcha_timer) {
        clearTimeout(this.captcha_timer);
        this.captcha_timer = null;
      }
    },
    setAntibotKey(recaptchaToken) {
      this.postAbKey({'g-recaptcha-response-data': recaptchaToken}, recaptchaToken);
    },
    setSmartAntibotKey(token) {
      this.postAbKey({'smart-token': token}, token);
    },
    postAbKey(params, token) {
      this.clearCaptchaTimeout();
      this.captcha_failed = false;
			axios
        .post('/api/calculator/set_ab_key',params)
				.then( res => {
          $cookies.set('Ab', token, '1y', '/', '.' + main_domain); //half year
          if (document.referrer) {
            let referrer = new URL(document.referrer).host;
            let url_to_go = new URL(location.href);
            url_to_go.searchParams.append('utm_referrer', referrer);
            url_to_go.searchParams.append('utm_source', referrer);
            window.location = url_to_go.toString();
          } else {
            window.location.reload();
          }
				})
				.catch( err => {
					console.error(err);
          this.captchaError('server rejected captcha');
				})
    },
    retryCaptcha() {
      const captcha = this.activeCaptchaRef();
      if (captcha) {
        try { captcha.reset(); } catch (e) { /* not rendered yet */ }
      }
      this.validateCaptcha();
    },
    captchaError(error) {
      this.clearCaptchaTimeout();
      this.captcha_failed = true;
      console.error("captcha error", error);
    },
  },
}
</script>
<script setup>

import { ref } from 'vue';
import { VueRecaptcha } from 'vue-recaptcha';
import SmartCaptchaInvisible from './components/SmartCaptchaInvisible.vue';

import { useDisplay } from 'vuetify';
const { mobile } = useDisplay();

import { getPublickImgURL } from './composables/getPublickImgUrl.js'

let url = `antibot_background${mobile.value ? '_mobile' : ''}.webp`;
const imgUrl = ref(getPublickImgURL(url));

</script>
<style type="text/css" lang="scss" media="screen">
.styled-var {
  cursor: pointer;
  border-radius: 3px;
  width: 60px;
  text-align: center;
}
</style>
